export enum UserRole {
    Admin    = 'admin',
    Support  = 'support',
    ReadOnly = 'readonly',
}
